import { Component, inject, signal } from "@angular/core";
import { VDS_ALERT_DATA, type VdsAlertType } from "@cce/design-system/alert-domain";
import { VdsAlertRef } from "./alert-ref";
import { VdsIconComponent } from "@cce/design-system/icon";

/**
 * A component used to open as the default alert, matching material spec.
 * This should only be used internally by the alert service.
 */
@Component({
    selector: "vds-default-alert",
    templateUrl: "./default-alert.component.html",
    host: {
        class: "vds-alert__content"
    },
    imports: [VdsIconComponent]
})
export class DefaultAlertComponent {
    private vdsAlertRef = inject(VdsAlertRef<DefaultAlertComponent>);
    private data = inject<{ title: string; message: string; action: string }>(VDS_ALERT_DATA);

    readonly title = signal<string>(this.data.title);
    readonly message = signal<string>(this.data.message);
    readonly type = signal<VdsAlertType | undefined>(this.vdsAlertRef?.containerInstance?.alertConfig?.alertType);

    /** Performs the action on the alert. */
    action(): void {
        this.vdsAlertRef.dismissWithAction();
    }

    readonly hasAction = signal<boolean>(!!this.data.action);
    readonly actionLabel = signal<string>(this.data.action);
}
